import {Button, Radio, useTranslationContext} from 'platform/components';
import {Box, Grid, Show, Text, VStack} from 'platform/foundation';

import {useSyncExternalStore} from 'react';

import {isNil} from 'ramda';

import type {BulkOperationActionContext} from '../../types/BulkOperationActionCallback';
import {getAvailableBulkOperationTargets} from '../../utils/getAvailableBulkOperationTargets';

export function BulkOperationScopeField(props: {context: BulkOperationActionContext}) {
  const t = useTranslationContext();
  const state = useSyncExternalStore(props.context.subscribe, props.context.getSnapshot);
  const targets = getAvailableBulkOperationTargets(state.selection);
  const scopes = [
    {
      value: 'selected',
      label: t('general.labels.selected'),
      count: state.selection.recordIds.length,
    },
    {
      value: 'filtered',
      label: t('page.datagrid.labels.filtered'),
      count: state.selection.query.totalCount ?? 0,
    },
  ] as const;

  return (
    <VStack spacing={3}>
      <div role="radiogroup" aria-label={t('general.actions.bulkActions')}>
        <Grid columns={[1, 2]} spacing={3}>
          {scopes.map((scope) => (
            <div key={scope.value} role="group" aria-label={`${scope.label}: ${scope.count}`}>
              <Box
                padding={4}
                border="thin solid"
                borderColor={state.scope === scope.value ? 'general.accent' : 'general.separator'}
                backgroundColor={
                  state.scope === scope.value ? 'palettes.blue.10.100' : 'general.white'
                }
                borderRadius="medium"
                opacity={isNil(targets[scope.value]) ? 0.5 : 1}
              >
                <VStack spacing={3}>
                  <Radio
                    name="bulkOperationScope"
                    value={state.scope}
                    onChange={() => props.context.setScope(scope.value)}
                    options={[{value: scope.value, label: scope.label}]}
                    isDisabled={state.isSubmitting || isNil(targets[scope.value])}
                  />
                  <Text size="large">
                    <strong>{scope.count}</strong>
                  </Text>
                </VStack>
              </Box>
            </div>
          ))}
        </Grid>
      </div>
      <Show when={state.requiresConfirmation}>
        <Button
          title={t('general.actions.refresh')}
          onClick={props.context.confirmTarget}
          isDisabled={state.isSubmitting}
        />
      </Show>
    </VStack>
  );
}
